var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Model",
    {
      attrs: {
        form: _vm.form,
        "init-form": _vm.initForm,
        "is-show": _vm.isShowModel,
        "custom-title": _vm.dialogTitle,
        "save-item": _vm.saveItem,
        "can-submit": _vm.canSubmit,
        "is-only-confirm": _vm.mode === "view",
        "confirm-btn-text": _vm.mode === "view" ? "back" : "confirm",
        "auto-height": "",
        top: "10vh",
      },
      on: {
        "update:isShow": function ($event) {
          _vm.isShowModel = $event
        },
        "update:is-show": function ($event) {
          _vm.isShowModel = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: !_vm.canSubmit,
              expression: "!canSubmit",
            },
          ],
          staticClass: "container",
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: { model: _vm.form, rules: _vm.rules, size: "small" },
            },
            [
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("doubleWeekPlan.input.taskDate"),
                      "label-width": _vm.formLabelWidth,
                    },
                  },
                  [
                    _c("FormDatePicker", {
                      attrs: {
                        mode: "view",
                        val: _vm.info.planTaskDate,
                        type: "date",
                        valueformat: "yyyyMMdd",
                      },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.info, "planTaskDate", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("doubleWeekPlan.input.taskType"),
                      "label-width": _vm.formLabelWidth,
                    },
                  },
                  [
                    _c("FormSelect", {
                      attrs: {
                        val: _vm.info.planTaskType,
                        options: _vm.optConfig.planTypeOptions,
                        mode: "view",
                      },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.info, "planTaskType", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("common.startDatetime"),
                      "label-width": _vm.formLabelWidth,
                    },
                  },
                  [
                    _c("FormInput", {
                      attrs: { val: _vm.info.planTaskStartTime, mode: "view" },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.info, "planTaskStartTime", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("common.EndDatetime"),
                      "label-width": _vm.formLabelWidth,
                    },
                  },
                  [
                    _c("FormInput", {
                      attrs: { val: _vm.info.planTaskEndTime, mode: "view" },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.info, "planTaskEndTime", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              _vm._v(" "),
              _vm.isVisitType
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("doubleWeekPlan.input.srName"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          mode: "view",
                          labelKey: "empName",
                          valueKey: "empNo",
                          val: _vm.info.srEmpName,
                          options: _vm.srList,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.info, "srEmpName", $event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isVisitType
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("doubleWeekPlan.table.storeName"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.info.storeName, mode: "view" },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.info, "storeName", $event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isVisitType
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("doubleWeekPlan.input.storeContact"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.info.contactor, mode: "view" },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.info, "contactor", $event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isVisitType
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("doubleWeekPlan.table.storeCode"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.info.storeCode, mode: "view" },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.info, "storeCode", $event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isVisitType
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("doubleWeekPlan.table.PCD"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.info.PCD, mode: "view" },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.info, "PCD", $event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isVisitType
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("doubleWeekPlan.table.storeAddress"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.info.storeAddress, mode: "view" },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.info, "storeAddress", $event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isVisitType
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("doubleWeekPlan.input.customerName"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { mode: "view", val: _vm.info.customerName },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.info, "customerName", $event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isVisitType
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("doubleWeekPlan.input.customerAddress"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { mode: "view", val: _vm.info.customerAddress },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.info, "customerAddress", $event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isVisitType
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("doubleWeekPlan.input.target1"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.info.visitPurposeOne,
                          options: _vm.optConfig.visitPurposeOptions,
                          mode: "view",
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.info, "visitPurposeOne", $event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isVisitType
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("doubleWeekPlan.input.target2"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.info.visitPurposeTwo,
                          options: _vm.optConfig.visitPurposeOptions,
                          mode: "view",
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.info, "visitPurposeTwo", $event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isVisitType
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("doubleWeekPlan.input.asmVisitPurpose"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.info.asmVisitPurpose,
                          options: _vm.optConfig.asmVisitPurposeOptions,
                          mode: "view",
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.info, "asmVisitPurpose", $event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("doubleWeekPlan.input.desc"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormTextArea", {
                    attrs: {
                      val: _vm.form.remark,
                      rows: 4,
                      maxlength: "100",
                      mode: _vm.mode,
                      disabled: "",
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "remark", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isVisitType
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("doubleWeekPlan.input.asmVisitSummary"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormTextArea", {
                        attrs: {
                          val: _vm.form.asmVisitSummary,
                          rows: 4,
                          maxlength: "100",
                          mode: _vm.mode,
                          disabled:
                            _vm.info.actualPlanTaskFlag === _vm.PT_STATUS_TASK,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.form, "asmVisitSummary", $event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.info.collaborativeFlag
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("doubleWeekPlan.input.collaborativeFlag"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          mode: _vm.mode,
                          val: _vm.info.collaborativeFlag,
                          options: _vm.optConfig.YNOptions,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.info,
                              "collaborativeFlag",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("TimeConflictModel", {
        ref: "timeConflictModel",
        attrs: { "opt-config": _vm.optConfig },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }